import $ from 'jquery'
import {MainNav} from "./components/main-nav";
import {UiUtils} from "./utils/ui-utils";
import {Carousel} from './modules/carousel';
import '../../css/frontend/site.scss';
import {ScrollAnimation} from "./ui-effects/ScrollAnimation.js";
import {PlayerJs} from "./modules/playerjs.js";
import {Animation} from "./modules/animation.js";
import {NavSearch} from "./modules/nav-search.js";
import {PrintHide} from "./modules/print-hide.js";
import {InfluencerForm} from "./modules/influencer-form.js";
import {PdpGallery} from "./modules/pdp-gallery.js";

window.$ = window.jQuery = $

// The following snippet is used to automatically refresh the browser if the user screen size changes (i.e. if the user has a tablet and it rotates from vertical to horizontal). This allows to load all the mobile features or avoid to load the mobile features if not needed.
const mediaQueryList = window.matchMedia(UiUtils.mobileMediaQuery);
let isPrinting = false;
mediaQueryList.addEventListener('change', event => {
  const printMediaCheck = window.matchMedia('print');
  if(printMediaCheck.matches) {
    // we are printing, do not refresh the page
    isPrinting = true;
  }
  else {
    if(isPrinting) {
      // we are just finished printing, do not refresh the page
      isPrinting = false;
    }
    else {
      location.replace(location.href);
    }
  }
  // console.log(event);
})

const mainNav = new MainNav();
const carousel = new Carousel();
const scrollAnimation = new ScrollAnimation();
const playerjs = new PlayerJs();
const animation = new Animation();
const navSearch = new NavSearch();
const printHide = new PrintHide();
const influencerForm = new InfluencerForm();
const pdpGallery = new PdpGallery();

// Embla APIs
window.emblaApis = []

document.addEventListener('DOMContentLoaded', () => {
    mainNav.init();
    pdpGallery.init();
    carousel.init();
    scrollAnimation.init();
    playerjs.init();
    animation.init();
    navSearch.init();
    printHide.init();
    influencerForm.init();
})
